import {
  setActiveWa,
  setDataWa,
  setErrorWa,
  setLoadingWa,
  setOutdatedCode,
  setUpdateWa,
} from "../../../../store/slices/integrationSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

// Получение QR-кода вацап
export const getQrCodeWa = (dataWa, setImage = () => {}, closeModal) => {
  return async (dispatch) => {
    dispatch(setLoadingWa(true)); // Включаем загрузку
    dispatch(setOutdatedCode(false));

    try {
      const { data } = await $authHost.post(
        `/integrations/whatsapp/initialization`,
        dataWa
      );

      if (data.code === 200) {
        setImage(data.qrCode);
      } else if (data.code === 401) {
        dispatch(removeUser());
      }

      if (data.initState === "success") {
        dispatch(getWhatsappIntegrations(dataWa.userId));
        closeModal();
      }
    } catch (error) {
      if (error.response) {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }
      console.error("Error getQrCodeWa:", error);
    } finally {
      dispatch(setLoadingWa(false)); // Заканчиваем загрузку
    }
  };
};

// Получение списка вацап аккаунтов
export const getWhatsappIntegrations = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/whatsapp/list?userId=${userId}`
      );

      if (data.code === 200) {
        dispatch(setDataWa(data.users));
      } else {
        errorToast(
          `Ошибка получения интеграций WhatsApp. Обновите страницу. Код ошибки: ${data.code}`
        );
      }
    } catch (error) {
      if (error.response) {
        const { status } = error.response;

        if (status === 401) {
          dispatch(removeUser());
        } else if (status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }
      console.error("Error get wa integrations:", error);
    }
  };
};

// Получение конкретной интеграции
export const getWhatsappIntegration = (userId, externalWhatsappId) => {
  return async (dispatch) => {
    dispatch(setLoadingWa(true));
    dispatch(setErrorWa(false));
    try {
      const { data } = await $authHost.get(
        `/integrations/whatsapp?userId=${userId}&externalWhatsappId=${externalWhatsappId}`
      );

      if (data.code === 200) {
        dispatch(setLoadingWa(false));
        localStorage.setItem("dataWa", JSON.stringify(data.user));
        dispatch(setActiveWa(data.user));
      } else {
        errorToast(
          `Ошибка получения интеграции WhatsApp. Обновите страницу. Код ошибки: ${data.code}`
        );
      }
    } catch (error) {
      dispatch(setLoadingWa(false));
      dispatch(setErrorWa(true));

      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("error get wa integration", error);
    }
  };
};

// Обновление вацапа
export const configureWhatsappClient = (configuration, externalWhatsappId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/whatsapp/client`,
        configuration
      );
      if (data) {
        dispatch(getWhatsappIntegration(userId, externalWhatsappId));
      }
      if (data.code === 200) {
        dispatch(setUpdateWa(false));
      } else {
        errorToast(`Ошибка: ${data.message || "Неизвестная ошибка."}`);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }
      console.log("configureWhatsappClient error:", error);
    }
  };
};

// Деактивация вацапа
export const deactivateWhatsapp = (dataDeactivation, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/whatsapp/deactivation`,
        dataDeactivation
      );
      if (data.code === 200) {
        localStorage.removeItem("dataWa");
        setLoading(false);
        dispatch(setActiveWa(null));
        dispatch(getWhatsappIntegrations(dataDeactivation.userId));
        navigate("/integration");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.data.message === "error: client not found") {
          errorToast("Ошибка деактивации. Клиент не найден");
          dispatch(getWhatsappIntegrations(dataDeactivation.userId));
        }
      } else {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      }
      console.log("deactivateWhatsapp error:", error);
    }
  };
};
